import styleInject from '../../node_modules/.pnpm/style-inject@0.3.0/node_modules/style-inject/dist/style-inject.es.js';
var css_248z = ".index-module_Container__uwyVd {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  z-index: 3;\n  pointer-events: none;\n}\n\n.index-module_Container__uwyVd * {\n  pointer-events: auto;\n}\n";
var OverlayModuleCss = {
  "Container": "index-module_Container__uwyVd"
};
styleInject(css_248z);
export { OverlayModuleCss as default };